/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

define(
	'jQuery.sidebarPDPWishListMenu'
,	[
		'jQuery'
]
,	function(
		jQuery
	)
{
	'use strict';

function Menu(el) {
	var wrapper = el;
    var last_opened_menu = wrapper;
    var root_ul = wrapper.find('.product-list-control-flyout-product-lists:first');
    //console.log(root_ul)
    var animating = false;
    var has_animation_support = detectAnimationSupport();
    var class_names = {
        menuOpened: 'header-sidebar-menu-opened-mobile',
        menuPath: 'header-sidebar-menu-path-mobile',
        menuTransition: 'header-sidebar-menu-transition-mobile',
        animateIn: 'header-sidebar-menu-flyer-in-mobile',
        animateOut: 'header-sidebar-menu-flyer-out-mobile',
        flyer: 'header-sidebar-menu-flyer-mobile'
    };
    var height_stack = [];

    // initializing menu
    last_opened_menu.addClass(class_names.menuPath);
    last_opened_menu.addClass(class_names.menuOpened);

    jQuery(root_ul).on('click', '[data-action="push-menu"]', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (animating === true) {
            return;
        }
        animating = true;

        var anchor = jQuery(this);
        var parent_li = anchor.closest('li');
        var pushing_menu = anchor.next();

        animate(pushing_menu, class_names.animateIn, function() {
            // change the last opened menu.
            last_opened_menu.removeClass(class_names.menuOpened);
            last_opened_menu = parent_li;

            // add current opened subview
            parent_li.addClass(class_names.menuPath).addClass(class_names.menuOpened);
        });
    });

    jQuery(root_ul).on('click', '[data-action="pop-menu"]', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (animating === true) {
            return;
        }
        animating = true;

        var anchor = jQuery(this); // anchor is the back button
        var anchor_menu = anchor.closest('ul');
        var opened_li = anchor.closest('.' + class_names.menuOpened);

        opened_li.removeClass(class_names.menuPath).removeClass(class_names.menuOpened);

        last_opened_menu = opened_li.closest('.' + class_names.menuPath);
        last_opened_menu.addClass(class_names.menuOpened);
        animate(anchor_menu, class_names.animateOut);
    });

    var flyer_className = '.' + class_names.flyer;
    jQuery(wrapper).on(
        'animationend MSAnimationEnd oAnimationEnd webkitAnimationEnd',
        flyer_className,
        function() {
            var cb = jQuery(this).data('callback');
            if (cb) {
                cb();
            }

            jQuery(this).remove();
            animating = false;
            root_ul.addClass(class_names.menuTransition); // fix ios transition glitch
        }
    );

    function animate(sub_menu, animation_class, cb) {
        var flyer_menu = sub_menu.clone(false);

        flyer_menu
            .removeClass()
            .addClass(class_names.flyer)
            .insertAfter(root_ul)
            .addClass(animation_class);

        if (animation_class === class_names.animateIn) {
            height_stack.push(root_ul.height());
            //root_ul.css('height', flyer_menu.height());
             root_ul.css('margin-top','2px')
           // console.log(jQuery(root_ul.children()).height())
            root_ul.css('height', jQuery(window).height() - 140);
        } else {
            root_ul.css('height', height_stack.pop());
            root_ul.css('margin-top','0px')
        }

        flyer_menu.data('callback', cb);

        if (!has_animation_support) {
            if (cb) {
                cb();
            }
            flyer_menu.remove();
            animating = false;
            root_ul.addClass(class_names.menuTransition); // fix ios transition glitch
        }
    }
}

function detectAnimationSupport() {
    var domPrefixes = 'Webkit Moz O ms Khtml'.split(' ');
    var elm = document.createElement('div');

    if (elm.style.animationName !== undefined) {
        return true;
    }

    for (var i = 0; i < domPrefixes.length; i++) {
        if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            return true;
        }
    }

    return false;
}


	jQuery.fn.sidebarMenu1 = function () {
		return this.each(function () {
			Menu(jQuery(this));
		});
	};

	return jQuery.fn.sidebarMenu1;

});
